import React from 'react';
import DataTables from 'components/dataTables';
import { connect } from 'react-redux';
import { PostAction } from 'redux/actions';
import PageSpinner from 'components/PageSpinner';
import { Card,Button } from 'reactstrap';
import PostContainer from './postContainer';
import TableCustomHeader from 'components/dataTables/tableCustomHeader';
import noImage from 'assets/img/users/no-image.jpg';
import Avatar from 'components/Avatar';
import { Link } from 'react-router-dom';
import { ConvertUtcToLocal, checkPermissions } from 'hooks';

const ReportedPost = (props) => {

    const isFirstRender = React.useRef(true);

    React.useEffect(() => {
        if (isFirstRender.current) {
            props.deletePostSuccess(null);
            isFirstRender.current = false;
            props.getPostDetailsSuccess(null)
        }
    })

    
    React.useEffect(() => {
        let filters = { page: props.pagination.page, page_limit: props.pagination.page_limit, order_by: props.order.order_by, direction: props.order.direction }
        props.getReportPosts(filters)

    }, [props.pagination, props.order]);

    React.useEffect(() => {

        props.getTotalCount(props.totalRecord);
    }, [props.postList])

    const customBody = (value, tableMeta, updateValue) => {
        return (tableMeta.columnData.name === 'image') ? 
        <Avatar src={(value) ? value : noImage}  /> 
        : (tableMeta.columnData.name === 'action') ?
        (checkPermissions(props.loginData, 'post_details'))?<Link className={'view-post-details'} to={`/post-details/${tableMeta.rowData[0]}`}><Button color="primary" className="border-0" >View Details</Button></Link>:
        <Button color="primary" disabled={true} className="border-0 btn-disabled" >View Details</Button>
        :(tableMeta.columnData.name === 'created_at') ? ConvertUtcToLocal(value,'MM-DD-YYYY')
        :value;
    }
    const columns = () => {
        let columnsList = [
            {
                name: "reported_post_id",
                label: "S.No.",
            },
            {
                name: "image",
                label: "Image",
            },
            {
                name: "title",
                label: "Title",
            },
            {
                name: "website",
                label: "Website",
            },
            {
                name: "reportedBy",
                label: "Reported By",
            },
            {
                name: "created_at",
                label: "Reported Date",
            },
            {
                name: "action",
                label: "Action",
            }
        ];
        return columnsList.map((column, index) => {
            return {
                label: column.label,
                name: column.name,
                options: {
                    customHeadRender: (columnMeta, updateDirection) => {
                        return <TableCustomHeader key={index} itemkey={index} order={props.order} columnMeta={columnMeta} updateDirection={updateDirection} />
                    },
                    customBodyRender: customBody,
                    display: (column.name === 'reported_post_id') ? false : true,
                    setCellProps: () => ({
                        style: (column.name === 'website' || column.name === 'title') ? { maxWidth: "180px" } :(column.name === 'action') ? { maxWidth: "100px" }: { width: 'auto' }
                    }),

                }
            }
        })
    }



    return (
        <Card className="mb-3">
            {props.isLoading ? <PageSpinner />
                : <DataTables data={props.postList} columns={columns()} options={props.options} />
            }
        </Card>
    );
}
const mapStateToProps = (state) => ({
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
    postList: (state.post && state.post.reportPost && state.post.reportPost.posts) ? state.post.reportPost.posts : [],
    totalRecord: (state.post && state.post.reportPost && state.post.reportPost.total_posts) ? state.post.reportPost.total_posts : 0,
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
});
const mapDispatchToProps = (dispatch) => ({
    getReportPosts: (payload) => dispatch(PostAction.getReportPosts(payload)),
    deletePostSuccess: (payload) => dispatch(PostAction.deletePostSuccess(payload)),
    getPostDetailsSuccess: (payload) => dispatch(PostAction.getPostDetailsSuccess(payload)),
});
export default PostContainer(connect(mapStateToProps, mapDispatchToProps)(ReportedPost), { defaultOrderBy: 'id' });